module.exports = __webpack_public_path__ + "media/Nav.2986c363.mp4";